/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Balance_Short_To_PayInputs */

const en_balance_short_to_pay = /** @type {(inputs: Balance_Short_To_PayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} to pay`)
};

const he_balance_short_to_pay = /** @type {(inputs: Balance_Short_To_PayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`₪${i?.amount} לתשלום`)
};

/**
* | output |
* | --- |
* | "₪{amount} to pay" |
*
* @param {Balance_Short_To_PayInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const balance_short_to_pay = /** @type {((inputs: Balance_Short_To_PayInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Balance_Short_To_PayInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_balance_short_to_pay(inputs)
	return he_balance_short_to_pay(inputs)
});